export const USER_RIGHTS = {
  ALL: 'All',
  EDIT_LEAD_CARD_PROCESSING_SETTINGS: 'Edit Lead CP setting',
  CHANGE_CREATE_MARKETING_DATA: 'Create/Change marketing data',
  CALL_ACCOUNTING: 'Call Accounting',
  ACCESS_CRM: 'Access CRM',
  DETAILS_VIEW_ALL: 'Details View All',
  DETAILS_VIEW_PHONE_ALL: 'Details View Phone All',
  DETAILS_EDIT_PHONE_ALL: 'Details Edit Phone All',
  ALLOW_ASSIGNMENT_ALL: 'Allow Assignment All',
  CHANGE_REGISTRATION_ATTEMPTS: 'Change Registration Attempts',
  EXPORT: 'Export',
  EXCEL_VIEW_EMAIL: 'Excel View Email',
  DETAILS_VIEW_ASSIGNED: 'Details View Assigned',
  DETAILS_VIEW_PHONE_ASSIGNED: 'Details View Phone Assigned',
  DETAILS_EDIT_PHONE_ASSIGNED: 'Details Edit Phone Assigned',
  ALLOW_ASSIGNMENT_ASSIGNED: 'Allow Assignment Assigned',
  VIEW_TRACKING_LINKS: 'View Tracking Links',
  VIEW_COMPLIANCE_INFO: 'View Compliance Info',
  EDIT_COMPLIANCE_INFO: 'Edit Compliance Info',
  EDIT_EMAIL: 'Edit Email',
  ACCOUNTS_PROMO_VIEW: 'Accounts Promo View',
  ACCOUNTS_PROMO_EDIT: 'Accounts Promo Edit',
  CHANGE_BRAND: 'Change Lead Brand',
  BALANCES_CREATE_DEBIT_CREDIT: 'Balances Create Debit/Credit',
  SYNC_MAIL_GROUPS: 'Sync Mail groups',
  RESET_2FA: 'Reset Client 2FA',
  VIEW_WEBAPP_SETTINGS: 'View WebApp Settings',
  EDIT_WEBAPP_SETTINGS: 'Edit WebApp Settings',
  SYNCHRONIZATION_TOOL: 'Synchronization tool',
  EXPORT_HEDGE_DEALS: 'Export Hedge Deals',
  SMS_GROUPS_VIEW: 'Sms Groups View',
  SMS_GROUPS_EDIT: 'Sms Groups Edit',
  SMS_CONTACT_VIEW: 'Sms Contact View',
  SMS_CONTACT_EDIT: 'Sms Contact Edit',
  SMS_SEND: 'Sms Send',
  SMS_TEMPLATE_EDIT: 'Sms Template Edit',
  SMS_COUNTRIES_VIEW: 'Sms Countries View',
  SMS_COUNTRIES_EDIT: 'Sms Countries Edit',
  EDIT_REGULATORY_IDENTITY_DATA: 'Edit Regulatory Identity Data',
  SMS_SIGNALS_HISTORY_VIEW: 'Sms Signals History View',
  PROMO_VIEW: 'Promo View',
  PROMO_EDIT: 'Promo Edit',
  VIEW_AUTOMATIC_LEAD_ASSIGNMENT: 'View Automatic Lead Assignment',
  EDIT_AUTOMATIC_LEAD_ASSIGNMENT: 'Edit Automatic Lead Assignment',
  UPLOAD_LEADS: 'Upload Leads',
  VIEW_MARKETING_ATTEMPTS: 'View Marketing Attempts',
  EXPOSURE_VIEW: 'Exposure View',
  TRANSACTION_VIEW_ALL: 'Transaction View All',
  TRANSACTION_VIEW_ASSIGNED: 'Transaction View Assigned',
  USER_LOGIN_HISTORY_VIEW_ALL: 'User Login History View All',
  USER_LOGIN_HISTORY_VIEW_ASSIGNED: 'User Login History View Assigned',
  PURCHASE_REPORT_VIEW_ALL: 'Purchase Report View All',
  PURCHASE_REPORT_VIEW_ASSIGNED: 'Purchase Report View Assigned',
  PERFORMANCE_VIEW_ALL: 'Performance View All',
  PERFORMANCE_VIEW_ASSIGNED: 'Performance View Assigned',
  SHORT_CLIENTS_VIEW_ALL: 'Short Clients View All',
  SHORT_CLIENTS_VIEW_ASSIGNED: 'Short Clients View Assigned',
  BALANCES_VIEW_ALL: 'Balances View All',
  BALANCES_VIEW_ASSIGNED: 'Balances View Assigned',
  CRYPTO_BALANCES_VIEW_ALL: 'Crypto Balances View All',
  CRYPTO_BALANCES_VIEW_ASSIGNED: 'Crypto Balances View Assigned',
  DEALS_VIEW_ALL: 'Deals View All',
  DEALS_VIEW_ASSIGNED: 'Deals View Assigned',
  MENU_MANAGEMENT: 'Menu Management',
  MANAGERS_EDIT: 'Managers Edit',
  VIEW_CARD_COMPLIANCE: 'View Card Compliance',
  CREATE_EDIT_MAIL_GROUPS: 'Create/Edit Mail groups',
  TRADING_SIGNALS: 'Trading Signals',
  VIEW_INTERNAL_MARKETING_CAMPAIGN: 'View Internal Marketing Campaign',
  VIEW_MARKETING_EVENTS_ASSIGNED: 'View Marketing Events Assigned',
  VIEW_MARKETING_EVENTS_ALL: 'View Marketing Events All',
  ALLOW_APPROVE_WITHDRAW_REQUEST: 'Allow Approve Withdraw Request',
  VIEW_ALL_MANAGERS: 'View All Managers',
  ACCESS_MYACCOUNT: 'Access MyAccount',
  DETAILS_EDIT_ALL: 'Details Edit All',
  VIEW_EMAIL_ALL: 'View Email All',
  VIEW_EMAIL_ASSIGNED: 'View Email Assigned',
  TRADING_ACCOUNT_ALL: 'Trading Account All',
  TRADING_ACCOUNT_UPDATE_ALL: 'Trading Account Update All',
  TRADING_ACCOUNT_UPDATE_ASSIGNED: 'Trading Account Update Assigned',
  TRADING_ACCOUNT_CHANGE_USER_GROUP_ALL:
    'Trading Account Change User Group All',
  TRADING_ACCOUNT_CHANGE_USER_GROUP_ASSIGNED:
    'Trading Account Change User Group Assigned',
  TRADING_ACCOUNT_MAKE_NOT_USED: 'Trading Account Make Not Used',
  LEAD_CREATIONS_RIGHTS: 'Lead Creation Rights',
  ALLOW_EMPTY_ASSIGNMENT: 'Allow Empty Assignment',
  ALLOW_NONDEPARTMENT_ASSIGNMENT: 'Allow NonDepartment Assignment',
  ALLOW_CLOSER_ASSIGNMENT: 'Allow Closer Assignment',
  ACCOUNTS_VIEW_ASSIGNED: 'Accounts View Assigned',
  DETAILS_EDIT_ASSIGNED: 'Details Edit Assigned',
  ALLOW_TRADING_ACCOUNT_OPERATIONS: 'Allow Trading Account Operations',
  VIEW_DEVELOPMENT_INFO: 'View Development Info',
  TRADING_ACCOUNT_ASSIGNED: 'Trading Account Assigned',
  CREDIT_CARD_CLEAR_ALL: 'Credit Card Clear All',
  CREDIT_CARD_CLEAR_ASSIGNED: 'Credit Card Clear Assigned',
  WITHDRAWS_VIEW_ALL: 'Withdraws View All',
  WITHDRAWS_VIEW_ASSIGNED: 'Withdraws View Assigned',
  PERFORM_DETLIX_OPERATIONS: 'Perform Deltix Operations',
  TRANSACTION_ALLOW_ASSIGN_INITIAL: 'Transaction Allow Assign Initial',
  PERFORM_LEADS_IMPORT: 'Perform Leads Import',
  ALLOW_ASSIGNMENT_BIZ_GROUP: 'Allow Assignment Biz Group',
  TRANSACTION_ALLOW_ASSIGN_CREATED_MANAGERS:
    'Transaction Allow Assign Created Managers',
  OLD_EMAIL_POLITICS_ALL: 'Old Email Politics All',
  CHANGE_DEALS: 'Change Deals',
  CALENDAR_EVENTS_RIGHTS: 'Calendar Event Rights',
  TRANSACTION_ALLOW_START_VERIFICATION: 'Transaction Allow Start Verification',
  ACCOUNTS_VIEW_ALL: 'Accounts View All',
  PRIOR_BONUS_ALL: 'Prior Bonus All',
  PRIOR_BONUS_ASSIGNED: 'Prior Bonus Assigned',
  COMPLIANCE_TEXT_TEMPLATES_EDIT: 'Compliance Text Templates Edit',
  FULLY_ACTIVATION_DATE_EDIT: 'Fully Activation Date Edit',
  CREATE_CHARGEBACK: 'Create Chargeback',
  VIEW_DOCUMENT_COMPLIANCE_INFO: 'View Document Compliance Info',
  CREATE_EXTERNAL_NOTIFICATIONS: 'Create External Notifications',
  CREATE_RECALL: 'Create Recall',
  PURCHASE_CREATE: 'Purchase Create',
  ALLOW_TOKENEXUS_LINK_GENERATION: 'Allow Tokenexus Link Generation',
  ALLOW_VAHETUS_PAYMENTS_LINK_GENERATION:
    'Allow Vahetus Payments Link Generation',
  ALLOW_CRYPTOWALLET_LINK_GENERATION: 'Allow CryptoWallet Generate Address',
  ALLOW_CHAT: 'Allow Chat',
  CRM_CHAT_INTEGRATION: 'Crm Chat Integration',
  CREDIT_CARD_EXTERNAL_TERMINAL: 'Credit Card External Terminal',
  CREATE_DEPOSIT_ALL: 'Create Deposit All',
  CREATE_DEPOSIT_ASSIGNED: 'Create Deposit Assigned',
  CLIENT_NAME_EDIT: 'Client Name Edit',
  PASSWORD_EDIT: 'Password Edit',
  TRANSACTION_ALLOW_UPDATE_DEPOSIT_STATUS_ALL:
    'Transaction Allow Update Deposit Status All',
  TRANSACTION_ALLOW_UPDATE_DEPOSIT_STATUS_ASSIGNED:
    'Transaction Allow Update Deposit Status Assigned',
  ALLOW_HLR_PHONE_VERIFICATION: 'Allow HLR Phone Verification',
  VIEW_HLR_PHONE_VERIFICATION_STATUS: 'View HLR Phone Verification Status',
  EDIT_CARD_PROCESSING_SETTINGS: 'Edit CP Settings',
  EXPORT_REGULATORY_REPORTS: 'Export Regulatory Reports',
  SMS_REPORT_VIEW: 'Sms Report View',
  DELETE_REGISTRATION_ATTEMPTS: 'Delete Registration Attempts',
  MARKETING_EVENTS_HISTORY: 'Marketing Events History',
  PAYMENT_SYSTEM_MERCHANTS_EDIT: 'Payment System Merchants Edit',
  DIVIDEND_MANAGEMENT_EDIT: 'Dividends Edit',
  DIVIDEND_MANAGEMENT_VIEW: 'Dividends Edit',
  SHOW_PHONE_WITH_TWO_FA: 'Show Phone With Two Fa',
  SHOW_PHONE_WITHOUT_TWO_FA: 'Show Phone Without Two Fa',
  LEAD_EXCEL_VIEW_PHONE: 'Excel View Phone Number',
  MYACCOUNT_SETTINGS: 'MyAccount Settings',
  MERCHANT_SETTINGS: 'Payment System Merchants Edit',
  BUSINESS_CENTER_VIEW: 'Business Center View',
  TEAMS_VIEW: 'Teams View',
  XCHAT_ALLOW_TO_CHAT_ALL: 'XChat Allow To Chat All',
  XCHAT_ALLOW_TO_CHAT_ASSIGNED: 'XChat Allow To Chat Assigned',
  COMPLIANCE_SETTINGS_EDIT: 'Compliance Settings Edit',
  CREATE_DEBIT_ALL: 'Create Debit All',
  CREATE_DEBIT_ASSIGNED: 'Create Debit Assigned',
  CREATE_CREDIT_ALL: 'Create Credit All',
  CREATE_CREDIT_ASSIGNED: 'Create Credit Assigned',
  SEND_AGREEMENTS_ASSIGNED: 'Send Agreements Assigned',
  SEND_AGREEMENTS_ALL: 'Send Agreements All',
  DELETE_COMPLIANCE_DOCUMENT: 'Delete Compliance Document',
  COMPLIANCE_ADDITIONAL_INFO: 'Compliance additional info',
  ALERTS_VIEW: 'Alerts View',
  CREATE_TRANSFER_BALANCE_ALL: 'Create Transfer Balance All',
  CREATE_TRANSFER_BALANCE_ASSIGNED: 'Create Transfer Balance Assigned',
  CREATE_WITHDRAW_ALL: 'Create Withdraw All',
  CREATE_WITHDRAW_ASSIGNED: 'Create Withdraw Assigned',
  CREATE_WITHDRAW_REQUEST_ALL: 'Create Withdraw Request All',
  CREATE_WITHDRAW_REQUEST_ASSIGNED: 'Create Withdraw Request Assigned',
  EDIT_MANAGER_COMMENT: 'Edit Manager Comment',
  DELETE_MANAGER_COMMENT: 'Delete Manager Comment',
} as const;

export const USER_BU_RIGHTS = {
  ALL: 'all',
  DETAILS_VIEW_PHONE_ALL: 'details View Phone All',
  DETAILS_VIEW_PHONE_ASSIGNED: 'details View Phone Assigned',
  ACCOUNTS_PROMO_EDIT: 'accounts Promo Edit',
  DETAILS_VIEW_ASSIGNED: 'details View Assigned',
  DETAILS_VIEW_ALL: 'details View All',
  ALLOW_ASSIGNMENT_ASSIGNED: 'allow Assignment Assigned',
  ALLOW_ASSIGNMENT_ALL: 'allow Assignment All',
  VIEW_TRACKING_LINKS: 'view Tracking Links',
  ALLOW_ASSIGNMENT_BIZ_GROUP: 'allow Assignment Biz Group',
  LEAD_CREATION_RIGHTS: 'lead Creation Rights',
} as const;

export const CHAT_RIGHTS = {
  GROUP_IMPORT_CONTACTS_RIGHT: 'GROUP_IMPORT_CONTACTS_RIGHT',
} as const;

export const IS_BU_RIGHT = {
  [USER_RIGHTS.CREATE_DEPOSIT_ALL]: true,
  [USER_RIGHTS.CREATE_DEPOSIT_ASSIGNED]: true,
  [USER_RIGHTS.ALLOW_TOKENEXUS_LINK_GENERATION]: false,
  [USER_RIGHTS.ALLOW_VAHETUS_PAYMENTS_LINK_GENERATION]: false,
  [USER_RIGHTS.ALLOW_CRYPTOWALLET_LINK_GENERATION]: false,
  [USER_RIGHTS.ACCOUNTS_PROMO_VIEW]: true,
  [USER_RIGHTS.MARKETING_EVENTS_HISTORY]: true,
  [USER_RIGHTS.CREATE_TRANSFER_BALANCE_ALL]: true,
  [USER_RIGHTS.CREATE_TRANSFER_BALANCE_ASSIGNED]: true,
  [USER_RIGHTS.CREATE_WITHDRAW_ALL]: true,
  [USER_RIGHTS.CREATE_WITHDRAW_ASSIGNED]: true,
  [USER_RIGHTS.CREATE_WITHDRAW_REQUEST_ALL]: true,
  [USER_RIGHTS.CREATE_WITHDRAW_REQUEST_ASSIGNED]: true,
};
